import { AvailabilityPrinter } from '@wix/wixrest-utils';

export const getAvailabilityParsedByDaysAndHours = availability => {
  const PERIOD_DELIMITER = '---';
  const DAYS_END_DELIMITER = '***';

  const getPeriodDelimiter = () => {
    return '---';
  };

  const getDaysEnd = function() {
    return '***';
  };

  const parsedAvailability = AvailabilityPrinter.prettyPrint(availability, {
    getDaysEnd,
    getPeriodDelimiter,
  });
  const availabilityPeriods = parsedAvailability.split(PERIOD_DELIMITER);
  return availabilityPeriods.map(period => {
    const [days, hours] = period.split(DAYS_END_DELIMITER);
    return { days, hours };
  });
};
